import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { fromGlobalId } from 'graphql-relay';
import { FormattedDate, FormattedMessage } from 'react-intl';
import some from 'lodash/some';
import List from '../../components/List';
import Button from '../../components/Button';
import REPVISITS_LOCATION_TYPE from '../../utils/repvisits-location-types';
import messages from './messages';

import './styles.css';

const getAvailabilityLink = (institution) => `/rep-visits/search/${fromGlobalId(institution.id).id}/visits`;

export const toDateStringYYYYMMDD = (date) => {
  // fix the zero indexed month
  const month = `0${(date.getMonth()+1)}`.slice(-2);
  const dayOfMonth = `0${(date.getDate())}`.slice(-2);
  return `${date.getFullYear()}-${month}-${dayOfMonth}`; // YYYY-MM-DD
};

export const getEvents = (viewerRepVisitsEvents) => {
  const events = {};
  const eventsList = [];
  const date = new Date();
  const today = toDateStringYYYYMMDD(date);
  // item.date is already in YYYY-MM-DD format
  const isFuture = some(viewerRepVisitsEvents, (item) => item.date >= today);

  viewerRepVisitsEvents.forEach((item) => {
    if (isFuture) {
      if (item.date >= today) {
        eventsList.push(item);
      }
    } else if (!isFuture) {
      if (item.date < today) {
        eventsList.push(item);
      }
    }
  });

  events.isFuture = isFuture;
  events.list = eventsList;
  return events;
};

const ViewAvailabilityLink = ({ institution, events }) => (
  <div>
    { !events.list.length && (
    <div>
      <List.Item styleName="result-action-container">
        <span styleName="result-action-upcoming">
          <FormattedMessage {...messages.previousAppointments} />
        </span>
      </List.Item>
      <List.Item styleName="result-action-container">
        <span styleName="result-action-italic">
          <FormattedMessage {...messages.nothingScheduledYet} />
        </span>
      </List.Item>
    </div>
    )}
    { !events.isFuture && (
    <List.Item styleName="result-action-container availability-list-item">
      <Button
        styleName="result-action-availability-btn padding-btn"
        as={Link}
        to={getAvailabilityLink(institution)}
      >
        <FormattedMessage {...messages.viewAvailability} />
      </Button>
    </List.Item>
    )}
  </div>
);

ViewAvailabilityLink.propTypes = {
  institution: PropTypes.object,
  events: PropTypes.array,
};

class FairAndVisitLinks extends React.PureComponent {
  static propTypes = {
    institution: PropTypes.object,
    showSideBar: PropTypes.func.isRequired,
  };

  renderCollegeFairs = (event) => {
    if (event.userBookingStatus === 'APPROVED') {
      return (
        <span styleName="result-action-bold">
          <div styleName="fair-symbol" /><FormattedMessage {...messages.collegeFair} />
        </span>
      );
    } else if (event.userBookingStatus === 'PENDING') {
      return (
        <span styleName="result-action-bold">
          <div styleName="pending-symbol" /><FormattedMessage {...messages.pendingCollegeFair} />
        </span>
      );
    }
    return null;
  };

  renderVisits = (event) => {
    const isVisitApproved = event.userBookingStatus === 'APPROVED';

    if (event.userBookingStatus === 'PENDING') {
      return (
        <span styleName="result-action-bold">
          <div styleName="pending-symbol" /><FormattedMessage {...messages.pendingVisit} />
        </span>
      );
    } else if (isVisitApproved && event.chosenVisitLocationType === REPVISITS_LOCATION_TYPE.VIRTUAL) {
      return (
        <span
          styleName="result-action-bold"
          data-cy="repvisits-travel-plan-virtual-visit"
        >
          <div styleName="virtual-visit-symbol" /><FormattedMessage {...messages.virtualVisit} />
        </span>
      );
    } else if (isVisitApproved) {
      return (
        <span
          styleName="result-action-bold"
          data-cy="repvisits-travel-plan-in-person-visit"
        >
          <div styleName="in-person-visit-symbol" /><FormattedMessage {...messages.inPersonVisit} />
        </span>
      );
    } else return null;
  };

  renderEvents = (event) => {
    if (event.name) {
      return this.renderCollegeFairs(event);
    } else {
      return this.renderVisits(event);
    }
  };

  render() {
    const { institution } = this.props;
    const dataCyInstitution = institution.name.split(' ').join('-');
    const formattedEvents = getEvents(institution.viewerRepVisitsEvents);
    return (
      <div>
        {
          formattedEvents.list.length ? (
            <List.Item styleName="result-action-container">
              {formattedEvents.isFuture ? (
                <span styleName="result-action-upcoming">
                  {formattedEvents.list.length}&nbsp;
                  {formattedEvents.list.length === 1 ?
                    <FormattedMessage {...messages.upcomingAppointment} /> :
                    <FormattedMessage {...messages.upcomingAppointments} />}
                </span>
              ): (
                <span styleName="result-action-upcoming">
                  {formattedEvents.list.length}&nbsp;
                  {formattedEvents.list.length === 1 ?
                    <FormattedMessage {...messages.pastAppointment} /> :
                    <FormattedMessage {...messages.pastAppointments} />}
                </span>
              )}
            </List.Item>
          ):
            ''
        }
        <List.Item data-cy={`repvisits-travel-plan-fairvisits-${dataCyInstitution}`}>
          {formattedEvents.list.map((event) => (
            <List.Content key={event.id} styleName="result-action-container">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link styleName="asLinkBtn" onClick={() => this.props.showSideBar(event)}>
                {this.renderEvents(event)}
                &nbsp;<FormattedDate value={`${event.date}T12:00:00`} year="numeric" month="long" day="numeric" />
              </Link>
            </List.Content>
          ))}
        </List.Item>
        <ViewAvailabilityLink institution={institution} events={formattedEvents || []} />
      </div>
    );
  }
}

export default FairAndVisitLinks;
